/* eslint-disable no-param-reassign */
import PropTypes from "prop-types";
import { extractData } from "../utils";

const SingleValue = ({ children, ...componentProps }) => {
  const Component = componentProps.selectProps?.custom?.SingleValue;

  if (!Component) {
    return null;
  }

  return (
    <Component componentProps={componentProps} data={extractData(componentProps)}>
      {children}
    </Component>
  );
};

SingleValue.propTypes = {
  selectProps: PropTypes.shape({
    custom: PropTypes.shape({
      SingleValue: PropTypes.func,
    }),
  }),
  children: PropTypes.node,
};

SingleValue.defaultProps = {
  selectProps: {
    custom: {
      SingleValue: null,
    },
  },
  children: null,
};

export default SingleValue;
